"use client";

import { c as _c } from "react/compiler-runtime";
import type { InAppNotification } from "@/stores/notificationStore";
import { stripMarkdown } from "@/lib/templates/stripMarkdown";
import { formatDistanceToNow } from "date-fns";
import Link from "next/link";
interface NotificationItemProps {
  notification: InAppNotification;
  onMarkRead: (id: string) => void;
  onNavigate?: () => void;
}
export function NotificationItem(t0) {
  const $ = _c(33);
  const {
    notification,
    onMarkRead,
    onNavigate
  } = t0;
  const link = typeof notification.data?.link === "string" ? notification.data.link : undefined;
  let t1;
  if ($[0] !== notification.id || $[1] !== notification.read || $[2] !== onMarkRead || $[3] !== onNavigate) {
    t1 = () => {
      if (!notification.read) {
        onMarkRead(notification.id);
      }
      onNavigate?.();
    };
    $[0] = notification.id;
    $[1] = notification.read;
    $[2] = onMarkRead;
    $[3] = onNavigate;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleClick = t1;
  const t2 = `h-2 w-2 rounded-full ${notification.read ? "bg-transparent" : "bg-blue-500"}`;
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="flex shrink-0 pt-1.5"><div className={t2} /></div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== notification.title) {
    t4 = <p className="body-sm-medium break-words">{notification.title}</p>;
    $[7] = notification.title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== notification.message) {
    t5 = stripMarkdown(notification.message);
    $[9] = notification.message;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <p className="label-xs mt-0.5 break-words">{t5}</p>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== notification.created_at) {
    t7 = formatDistanceToNow(new Date(notification.created_at), {
      addSuffix: true
    });
    $[13] = notification.created_at;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <p className="label-2xs text-ds-text-disabled dark:text-ds-text-muted mt-1">{t7}</p>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t9 = <div className="min-w-0 flex-1">{t4}{t6}{t8}</div>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t3 || $[22] !== t9) {
    t10 = <>{t3}{t9}</>;
    $[21] = t3;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const content = t10;
  const className = `flex w-full gap-3 rounded-lg px-3 py-3 text-left transition-colors hover:bg-ds-neutral-100 dark:hover:bg-ds-neutral-800 ${notification.read ? "opacity-60" : ""}`;
  if (link) {
    let t11;
    if ($[24] !== className || $[25] !== content || $[26] !== handleClick || $[27] !== link) {
      t11 = <Link href={link} onClick={handleClick} className={className}>{content}</Link>;
      $[24] = className;
      $[25] = content;
      $[26] = handleClick;
      $[27] = link;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    return t11;
  }
  let t11;
  if ($[29] !== className || $[30] !== content || $[31] !== handleClick) {
    t11 = <button onClick={handleClick} className={className}>{content}</button>;
    $[29] = className;
    $[30] = content;
    $[31] = handleClick;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
}